module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/First_criterium-contrast-fbabc40cf674c44a5acac9887fd2bfbe.svg";